import { useEffect, useRef } from 'react'

/**
 * 滚动进入视口时触发的渐显动画。
 * 监听 container 内的所有 .reveal 元素，为进入视口的元素添加 is-visible。
 */
export function useReveal<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T>(null)

  useEffect(() => {
    const root = ref.current
    if (!root) return

    const elements = Array.from(root.querySelectorAll<HTMLElement>('.reveal'))

    // 兼容不支持 IntersectionObserver 的环境
    if (typeof IntersectionObserver === 'undefined') {
      elements.forEach((el) => el.classList.add('is-visible'))
      return
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' },
    )

    elements.forEach((el) => observer.observe(el))
    return () => observer.disconnect()
  }, [])

  return ref
}
